// AUTHENTICATION ROUTES
// 1) Authenticate with LDAP (Does Not Require Auth):
export function AUTHENTICATION_URL() {
  return '/api/auth/login?app=nursing';
}
// 2) Renew Auth Token:
export function AUTHENTICATION_RENEW_URL() {
  return '/api/auth/renew';
}
// 3) Get Logged In User:
export function GET_LOGGED_IN_USER_URL() {
  return '/api/auth/logged_in_user';
}
// 4) Switch Logged In Users Selected Agency Contact:
export function SWTICH_AGENCY_CONTACT_URL(agencyId) {
  return `/api/switch_agency_contact/${agencyId}`;
}
// HEALTH CHECK ROUTES
// 1) Authenticate with LDAP (Does Not Require Auth):
export function HEALTH_CHECK_URL() {
  return '/api/health';
}
// MEDICAID PROCEDURE ROUTES
// 1) Get medicaid procedure list:
export function GET_MEDICAID_PROCEDURES_LIST_URL() {
  return '/api/medicaid_procedures';
}
// NURSING SCHEDULER ROUTES
// 1) Get scheduler provider list:
export function GET_SCHEDULER_PROVIDER_LIST_URL(searchString) {
  return `/api/nursing_scheduler/providers?search=${searchString}`;
}
// 2) Get Student Service List (Nursing Service By Provider):
export function GET_STUDENT_SERVICE_LIST_BY_PROVIDER_URL(providerUserId, schoolId, unassignedBool) {
  return `/api/nursing_scheduler/students_services_by_provider?provideruserid=${providerUserId}&schoolid=${schoolId}&unassignedonly=${unassignedBool}`;
}
// 3) Get Scheduler Student List:
export function GET_SCHEDULER_STUDENT_LIST_URL(searchString) {
  return `/api/nursing_scheduler/students?search=${searchString}`;
}
// 4) Get School List:
export function GET_SCHEDULER_SCHOOL_LIST_URL(searchString) {
  return `/api/nursing_scheduler/schools?search=${searchString}`;
}
// 5) Get Student Services List (Nursing Service By Student):
export function GET_STUDENT_SERVICE_LIST_BY_STUDENT_URL(studentId) {
  return `/api/nursing_scheduler/students_services_by_student?studentid=${studentId}`;
}
// 6) Provider List Search for Add New Provider to Service (Nursing Service By Student):
export function ADD_NEW_PROVIDER_TO_SERVICE_URL(serviceId, searchString) {
  return `/api/nursing_scheduler/students_services_by_student/${serviceId}/providers?search=${searchString}`;
}
// 7) Add a Provider to a Students Service and Team:
export function ADD_PROVIDER_TO_STUDENT_SERVICE_AND_TEAM_URL() {
  return '/api/nursing_scheduler/student_services/providers';
}
// 8) Remove a Provider from a Students Service and Team:
export function REMOVE_PROVIDER_FROM_STUDENT_SERVICE_AND_TEAM_URL(providerId) {
  return `/api/nursing_scheduler/student_services/providers/${providerId}`;
}
// NURSING SERVICE LOG ROUTES
// 1) Get active provider list
export function NSL_GET_ACTIVE_PROVIDER_LIST_URL(search) {
  return `/api/nursing_service_logs/providers/active?search=${search}`;
}
// 1) Get provider list:
export function NSL_PROVIDER_LIST_URL(search) {
  return `/api/nursing_service_logs/providers?search=${search}`;
}
// 2) Get providers school list:
export function NSL_PROVIDERS_SCHOOL_LIST_URL(providerUserId, search) {
  return `/api/nursing_service_logs/providers/${providerUserId}/schools?search=${search}`;
}
// 3) Get providers student services list:
export function NSL_PROVIDERS_STUDENT_SERVICES_LIST_URL(providerUserId, sort) {
  return `/api/nursing_service_logs/providers/${providerUserId}/student_services?sort=${sort}`;
}
// 4) Create a new Nursing Session:
export function NSL_CREATE_URL() {
  return '/api/nursing_service_logs';
}
// 5) Update a Nursing Session:
export function NSL_UPDATE_URL(sessionId) {
  return `/api/nursing_service_logs/${sessionId}`;
}
// 6) Upload a File Attachment:
export function NSL_UPLOAD_ATTACHMENT_URL(sessionId) {
  return `/api/nursing_service_logs/${sessionId}/files`;
}
// 7) Get file attachment:
export function NSL_GET_ATTACHMENT_URL(sessionId, attachmentId, token) {
  return `/api/nursing_service_logs/${sessionId}/files/${attachmentId}?token=${token}`;
}
// 8) Delete file attachment:
export function NSL_DELETE_ATTACHMENT_URL(sessionId, attachmentId) {
  return `/api/nursing_service_logs/${sessionId}/files/${attachmentId}`;
}
// 9) Get Nursing Session By ID:
export function NSL_GET_NURSING_SESSION_URL(sessionId) {
  return `/api/nursing_service_logs/${sessionId}`;
}
// 10) Delete Nursing Session:
export function DELETE_NURSING_SESSION_URL(sessionId) {
  return `/api/nursing_service_logs/${sessionId}`;
}
// 11) Get Student List For Nursing Session Listing DDL:
export function NSL_GET_STUDENT_LIST_FOR_DDL_URL(search) {
  return `/api/nursing_service_logs/students?search=${search}`;
}
// 12) Nursing Session Listing:
export function NSL_NURSING_SESSION_LISTING_URL(fromString, toString, providerUserId, studentId, locationId) {
  return `/api/nursing_service_logs/from=${fromString}&to=${toString}&provideruserid=${providerUserId}&studentid=${studentId}&locationid=${locationId}`;
}
// 13) Dashboard Listing:
export function NSL_DASHBOARD_LISTING_URL(numberOfDays) {
  return `/api/nursing_service_logs/dashboard?days=${numberOfDays}`;
}
// 14) Get Need Levels:
export function NEED_LEVELS_URL() {
  return '/api/nursing_service_logs/need_levels';
}
// 14) Get Delivery Modes:
export function DELIVERY_MODES_URL() {
  return '/api/nursing_service_logs/delivery_modes';
}
// 15) Get Supervisor Check Flags:
/** @return {string} */
export function GET_SUPERVISOR_FLAGS_URL(sessionId) {
  return `/api/nursing_service_logs/supervise_check?sessionId=${sessionId}`;
}
// SCHOOL ROUTES
// 1) Get school list:
export function GET_SCHOOL_LIST_URL(searchString) {
  return `/api/schools?search=${searchString}`;
}
// SERVICE LOCATION ROUTES
// 1) Get service location list:
export function GET_SERVICE_LOCATIONS_URL(searchString) {
  return `/api/service_locations?search=${searchString}`;
}
// STUDENT ROUTES
// 1) Get Student By ID:
export function GET_STUDENTS_BY_ID_URL(studentId) {
  return `/api/students/${studentId}`;
}
// USER ROUTES
// 1) Get Users Preferences:
export function GET_USER_PREFERENCES_URL(userId) {
  return `/api/users/${userId}/preferences`;
}
// 2) Get User Preference With Key:
export function GET_USER_PREFERENCES_WITH_KEY_URL(userId, preferenceKey) {
  return `/api/users/${userId}/preferences/${preferenceKey}`;
}
// 3) Get User Preference Value Options:
export function GET_USER_PREFERENCE_VALUE_OPTIONS_URL(userId, preferenceKey) {
  return `/api/users/${userId}/preferences/${preferenceKey}/options`;
}
// 4) Create a User Preference:
export function CREATE_USER_PREFERENCE_URL(userId) {
  return `/api/users/${userId}/preferences`;
}
// 5) Update a User Preference:
export function UPDATE_USER_PREFERENCE_URL(userId, preferenceKey) {
  return `/api/users/${userId}/preferences/${preferenceKey}`;
}

// NEED LEVEL ABSENT
export const ABSENT = 'ABSENT';

// DELIVERY MODE IN-PERSON
export const IN_PERSON = 'inperson';



// WEBPACK FOOTER //
// ./src/constants/index.js